export enum GridLayoutView{
    Map = 0,
    Grid
}